import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  isAuthenticated: boolean = false;
  private authSubscription!: Subscription;
  isSubmenuOpen = false;

  constructor(public apiService: ApiService, private storage: StorageService, private router: Router, public authService: AuthService, private snackBar: MatSnackBar) {
  }
  showMenu = false;
  toggleNavbar(){
    this.showMenu = !this.showMenu;
  }
  logout() {
    this.apiService.logout();
  }


  gotoDoctorsList() {
    this.storage.remove('selected-specialty');
    this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/doctors']);
    });
  }

  showSubmenu() {
    this.isSubmenuOpen = true;
  }

  hideSubmenu() {
    this.isSubmenuOpen = false;
  }

  ngOnInit() {
    this.authService.authStatus();
    this.authSubscription = this.authService.isAuthenticated.subscribe(status => {
      this.isAuthenticated = status;
    });
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
